import {
  tenantResolver,
  ETenantCode,
} from '@digital-platform/tenant-resolver-lib';

export const isCareplus = tenantResolver() === ETenantCode.CAREPLUS;
